import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { Scene3DEditor } from '@/components/3d-editor/Scene3DEditor';
import { Device3DManager } from '@/components/3d-editor/Device3DManager';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Settings, Eye } from 'lucide-react';

export const Route = createFileRoute(
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { sceneId } = Route.useParams();
  const navigate = useNavigate();

  return (
    <div className="flex h-screen bg-background">
      {/* Main 3D Editor */}
      <div className="flex-1 relative">
        <Scene3DEditor sceneId={sceneId} />

        {/* Header */}
        <Card className="absolute top-4 right-4 z-10">
          <CardHeader className="pb-2">
            <div className="flex items-center justify-between">
              <CardTitle className="text-lg">Scene Editor</CardTitle>
              <div className="flex gap-2">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() =>
                    navigate({
                      to: '/dashboard/scenes/$sceneId/view',
                      params: { sceneId },
                    })
                  }
                >
                  <Eye className="w-4 h-4 mr-2" />
                  Preview
                </Button>
                <Button size="sm" variant="outline" asChild>
                  <Link to="/dashboard/scenes">
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Back
                  </Link>
                </Button>
              </div>
            </div>
          </CardHeader>
        </Card>
      </div>

      {/* Right Sidebar */}
      <div className="w-80 border-l bg-card">
        <div className="p-4 border-b">
          <div className="flex items-center gap-2">
            <Settings className="w-5 h-5" />
            <h2 className="text-lg font-semibold">Scene Management</h2>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          <Device3DManager sceneId={sceneId} />
        </div>
      </div>
    </div>
  );
}
